import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

if (!url || !key) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY. ' +
      'Copy web/.env.example to web/.env.local and fill it in.',
  )
}

// The publishable/anon key is safe here. The anon role has no table privileges
// at all, so this key on its own cannot read a row — verified 2026-08-13
// against the live API. Data only becomes reachable once a signed-in user's
// JWT upgrades the request to the `authenticated` role, and even then every
// policy still requires an app_users row.
export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
